import { render, staticRenderFns } from "./PersonalResume.vue?vue&type=template&id=fdaf6748&scoped=true"
import script from "./PersonalResume.vue?vue&type=script&lang=js"
export * from "./PersonalResume.vue?vue&type=script&lang=js"
import style0 from "./PersonalResume.vue?vue&type=style&index=0&id=fdaf6748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdaf6748",
  null
  
)

export default component.exports